import { promiseError } from '@/store/utils';
import productService from '@/services/product';

interface IResult {
  name: string;
  qty: number;
  product: {
    id: string;
    name: string;
  };
}

interface IState {
  count: number;
  isLoading: boolean;
  result: IResult[];
}

interface IPayload {
  id: string;
  resource: string;
}

export default () => ({
  namespaced: true,
  state: () => ({
    count: 0,
    isLoading: false,
    result: [],
  } as IState),
  mutations: {
    IS_LOADING(state: IState, isLoading: boolean) {
      state.isLoading = isLoading;
    },
    LOAD_PRODUCT_USE(state: IState, response: IState) {
      state.count = response.count;
      state.result = response.result;
    },
  },
  actions: {
    loadProducts: ({ commit }: any, { id, resource }: IPayload) => {
      commit('IS_LOADING', true);
      return productService
        .getUse<IResult>(id, resource, `
          name
          qty
          product {
            id
            name
          }
        `)
        .then(response => commit('LOAD_PRODUCT_USE', response))
        .catch(promiseError(`PRODUCT_USE_LOAD`, commit))
        .finally(() => commit('IS_LOADING', false));
    },
  },
});
